import PropTypes from "prop-types";
import { FormFeedback, Input, Label } from "reactstrap";

const CurrencyInput = ({
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  placeholder = "Rp 0",
  disabled = false,
  required = false,
  invalid = false,
  error = "",
  className = "",
  prefix = "Rp",
}: any) => {
  const formatCurrency = (num: any) => {
    if (!num) return "";
    const numStr = num.toString().replace(/\D/g, "");
    return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const parseCurrency = (str: any) => {
    if (!str) return 0;
    return parseInt(str.toString().replace(/\D/g, ""), 10) || 0;
  };

  const handleChange = (e: any) => {
    const inputValue = e.target.value;
    const numericValue = parseCurrency(inputValue);

    if (onChange) {
      onChange({
        target: {
          name: name,
          value: numericValue,
        },
      });
    }
  };

  const displayValue = value ? `${prefix} ${formatCurrency(value)}` : "";

  return (
    <div className={`mb-3 ${className}`}>
      {label && (
        <Label htmlFor={id} className="form-label">
          {label}
          {required && <span className="text-danger"> *</span>}
        </Label>
      )}
      <Input
        type="text"
        className="form-control"
        id={id}
        name={name}
        placeholder={placeholder}
        value={displayValue}
        onChange={handleChange}
        onBlur={onBlur}
        disabled={disabled}
        invalid={invalid}
      />
      {invalid && error && <FormFeedback type="invalid">{error}</FormFeedback>}
    </div>
  );
};

CurrencyInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  invalid: PropTypes.bool,
  error: PropTypes.string,
  className: PropTypes.string,
  prefix: PropTypes.string,
};

export default CurrencyInput;

// ============================================
// CONTOH PENGGUNAAN DI UpdateModalSalary
// ============================================

// Import komponen
// import CurrencyInput from "components/CurrencyInput";

// Ganti input salary dengan:
/*
<CurrencyInput
  id="salary"
  name="salary"
  label="Nominal"
  value={validation.values.salary}
  onChange={validation.handleChange}
  onBlur={validation.handleBlur}
  required={true}
  invalid={validation.touched.salary && !!validation.errors.salary}
  error={validation.errors.salary}
/>
*/
